import { Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";

type Props = {
	seconds: number;
	formatLabel?: (seconds: number) => string;
};

const defaultFormat = (seconds: number) => `${seconds}s`;

const TimerChip = ({ seconds, formatLabel = defaultFormat }: Props) => {
	const theme = useAppTheme();

	return (
		<Box
			flexDirection="row"
			alignItems="center"
			paddingHorizontal={8}
			paddingVertical={4}
			borderWidth={1}
			borderColor={theme.colors.outlineVariant}
			borderRadius={theme.roundness * 2}
			backgroundColor={theme.colors.surface}
		>
			<Text
				variant="labelLarge"
				style={{ color: theme.colors.onSurface, fontWeight: "500" }}
				numberOfLines={1}
			>
				{formatLabel(seconds)}
			</Text>
		</Box>
	);
};

export default TimerChip;
